import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { MainLayout } from 'layout';
import {
  InfoPage,
  ContactsPage,
  ConsigneesPage,
  ApplicationWagonPage,
  ApplicationSupplyPage,
  ConsigneeCatalogPage,
  QueuePage,
  ContractsPage,
} from 'pages';

const UserRoutes = () => (
  <MainLayout>
    <Switch>
      <Route exact path="/queue" component={QueuePage} />
      <Route exact path="/profile" component={InfoPage} />
      <Route exact path="/profile/contacts" component={ContactsPage} />
      <Route exact path="/profile/contracts" component={ContractsPage} />
      <Route exact path="/profile/consignees" component={ConsigneesPage} />
      <Route
        exact
        path="/profile/applications"
        render={() => <Redirect to="/profile/applications/supply" />}
      />
      <Route exact path="/profile/applications/wagon" component={ApplicationWagonPage} />
      <Route exact path="/profile/applications/supply" component={ApplicationSupplyPage} />
      <Route exact path="/profile/applications/supply/archive" component={ApplicationSupplyPage} />
      <Route exact path="/consignees/catalog" component={ConsigneeCatalogPage} />
      <Redirect to="/queue" />
    </Switch>
  </MainLayout>
);

export default UserRoutes;
